import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CL, H2Rox } from "@/components/Typography";
import Device from "@/utils/device";
import MarketingButton from "../marketing/MarketingButton";

type Props = {
  formModalOpen: () => void;
};

const MoreBenefitsContent: FunctionComponent<Props> = ({ formModalOpen }) => {
  return (
    <S.Section data-cy="SF-content-2023">
      <S.CopyContainer>
        <H2Rox color={colours.shell} weight={100}>
          <S.ItalicWrap>Plus, </S.ItalicWrap>
          Many More Exclusive Benefits
        </H2Rox>
        <ul>
          <li>
            <CL color={colours.shell}>
              20% discount on private hire spaces at Old Sessions House for your
              meetings, parties or events
            </CL>
          </li>
          <br />
          <li>
            <CL color={colours.shell}>
              Discounted tickets to AllBright’s flagship events, including the
              Step Forward Summit and Live Well Festival
            </CL>
          </li>
          <br />
          <li>
            <CL color={colours.shell}>
              Exclusive brand benefits and discounts from specially selected
              partners
            </CL>
          </li>
        </ul>
        <MarketingButton
          buttonText="Register interest"
          colour={colours.shell}
          name="submit_button"
          textColour={colours.shell}
          type="button"
          onClick={formModalOpen}
        />
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10% 10%;
  background: ${colours.marketingBlue};
  display: flex;
  flex-direction: column;

  @media ${Device.tablet} {
    padding: 4% 10%;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${colours.shell};

  > ${H2Rox} {
    font-size: 2.5rem;
    line-height: 3rem;
  }

  @media ${Device.mobile} {
    gap: 30px;

    > ${H2Rox} {
      font-size: 3rem;
      line-height: 3.5rem;
    }
  }

  @media ${Device.desktop} {
    gap: 40px;

    align-items: center;
    > ${H2Rox} {
      font-size: 4rem;
      line-height: 4.5rem;
    }
  }

  @media ${Device.largeScreen} {
    > ${H2Rox} {
      font-size: 5rem;
      line-height: 5rem;
    }
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

export default MoreBenefitsContent;
